import { useWidth } from './useWidth'

export const useMobile = () => {
  const screenWidth = useWidth()
  return screenWidth < 950
}

export default useMobile
